export enum EducationLevel {    
    HighSchool = 1,
    Ged = 2,
    TechSchoolOrAssoc = 3,
    FourYearDegree = 4,
    AdvancedDegree = 5
}